import { FC } from 'react';
import { FaqListItemResponseDto } from '@/features/faq/types/faq-dto';
import FaqAdminCard from '@/features/faq/components/FaqAdminCard';
import { useFaqDetailsApi } from '../hooks/useFaqDetailsApi';

type Props = {
	list?: FaqListItemResponseDto[];
	onClick?: (id: string) => void;
	onEdit?: (id: string) => void;
	isMobile?: boolean;
};

const FaqAdminList: FC<Props> = ({ list, onClick, onEdit, isMobile }) => {
	const { updateFaqIndex } = useFaqDetailsApi();

	const handleDrop = async (id: string, newIndex: number) => {
		await updateFaqIndex({ id, newIndex });
	};

	return (
		<>
			{list?.map((faq) => (
				<FaqAdminCard
					key={faq.id}
					{...faq}
					onEdit={onEdit}
					onClick={onClick}
					onDragDrop={handleDrop}
					isMobile={isMobile}
				/>
			))}
		</>
	);
};

export default FaqAdminList;
